export type HomeAnalytics = {
  countries: number
  successes: number
  trainers: number
  users: number
}

export const mockHomeAnalytics: HomeAnalytics = {
  countries: 5,
  successes: 500,
  trainers: 48,
  users: 600,
}
